export const _getItemFromLocal = (key: string) => {
  return window.localStorage.getItem(key);
};

export const _setItemInLocal = (key: string, value: string) => {
  window.localStorage.setItem(key, value);
};

export const _removeItemFromLocal = (key: string) => {
  window.localStorage.removeItem(key);
};
